// styles
import { ActionFieldContainer } from './ActionField.styles.js'

export default function ActionField({ children }) {
  return (
    <ActionFieldContainer>
        {children}
    </ActionFieldContainer>
  )
}